import { FileUploader, FileUploaderConfig } from './FileUploader.js';

/**
 * お問い合わせフォーム用のファイルアップローダー
 */
export class ContactFileUploader extends FileUploader {
  
  // 親クラスのプライベートプロパティにアクセスするための型定義
  private boundHandleDelete!: (event: Event) => void;

  constructor(element: HTMLElement) {
    const config: FileUploaderConfig = {
      fileInputName: 'resume',
      nonceName: 'recruit_nonce',
      uploadAction: 'recruit_file_upload',
      deleteAction: 'recruit_file_delete',
      acceptedFileTypes: '.pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png',
      maxFileSize: 5242880, // 5MB
      messages: {
        deleteConfirm: 'アップロードしたファイルを削除しますか？'
      }
    };

    super(element, config);

    console.log('ContactFileUploader initialized - VERSION 2.0');

    // 親クラスでバインドされたhandleDeleteを、子クラスのメソッドで上書き
    (this as any).boundHandleDelete = this.handleDelete.bind(this);
    console.log('boundHandleDelete rebound to child class method');

    // 削除ボタンのイベントリスナーを再バインド（オーバーライドしたhandleDeleteを使用）
    this.bindDeleteButtons();

    // 初期化時に既にファイルが選択されている場合の処理
    this.checkInitialFileState();
  }

  /**
   * 初期化時のファイル状態をチェック
   */
  private checkInitialFileState(): void {
    const placeholderElement = this.container.querySelector('.js-file-placeholder');
    console.log('checkInitialFileState - placeholderElement:', placeholderElement);
    console.log('checkInitialFileState - textContent:', placeholderElement?.textContent);

    if (placeholderElement && placeholderElement.textContent && placeholderElement.textContent.trim() !== '' && placeholderElement.textContent !== '選択されていません') {
      console.log('File already exists, showing delete button');
      // ファイル名が既に表示されている場合、削除ボタンを表示
      const actionsElement = this.container.querySelector('.js-file-upload-actions') as HTMLElement;
      if (actionsElement) {
        actionsElement.classList.add('is-visible');
      }
    } else {
      console.log('No file found or placeholder is empty');
    }
  }
  
  /**
   * ファイル変更時の処理をオーバーライド（AJAX不使用、削除フラグのリセット）
   */
  protected handleFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('New file selected:', file.name);

      // 削除フラグを0にリセット（新しいファイルが選択されたので）
      const deleteFlag = this.container.querySelector('.js-delete-flag') as HTMLInputElement;
      if (deleteFlag) {
        deleteFlag.value = '0';
        console.log('Delete flag reset to 0 for:', deleteFlag.name);
      }

      // ファイル名を表示
      this.updateFileDisplay(file.name);
    }
  }

  /**
   * ファイル表示を更新
   */
  protected updateFileDisplay(fileName: string): void {
    // placeholderにファイル名を設定
    const placeholderElement = this.container.querySelector('.js-file-placeholder');
    if (placeholderElement) {
      placeholderElement.textContent = fileName;
    }

    // 削除ボタンを表示するためにアクションエリアを作成または表示
    this.showDeleteButton();

    // イベントリスナーを再設定
    this.reinitializeEventListeners();
  }

  /**
   * イベントリスナーを再設定
   */
  private reinitializeEventListeners(): void {
    // 全てのイベントリスナーを再設定
    this.bindAllEventListeners();
  }

  /**
   * ファイル表示を通常の選択状態にリセット
   */
  protected resetFileDisplay(): void {
    // placeholderを初期状態に戻す
    const placeholderElement = this.container.querySelector('.js-file-placeholder');
    if (placeholderElement) {
      placeholderElement.textContent = '選択されていません';
    }

    // 削除ボタンを非表示
    this.hideDeleteButton();

    // 全てのファイル入力をクリア
    const fileInputs = this.container.querySelectorAll(`input[name="${this.config.fileInputName}"]`);
    fileInputs.forEach(input => {
      (input as HTMLInputElement).value = '';
    });

    // 削除フラグを1に設定
    const deleteFlag = this.container.querySelector('.js-delete-flag') as HTMLInputElement;
    if (deleteFlag) {
      deleteFlag.value = '1';
      console.log('Delete flag set to 1 for:', deleteFlag.name);
    } else {
      console.warn('Delete flag not found in container');
    }

    // イベントリスナーを再設定
    this.reinitializeEventListeners();
  }

  /**
   * ファイル削除処理をオーバーライド（AJAX削除ではなく、フラグ設定のみ）
   */
  protected handleDelete(): void {
    console.log('handleDelete called - resetting file display');
    // 確認なしで即座にリセット（セッション管理の場合）
    this.resetFileDisplay();
  }

  /**
   * 削除ボタンを表示
   */
  private showDeleteButton(): void {
    const actionsElement = this.container.querySelector('.js-file-upload-actions') as HTMLElement;
    if (actionsElement) {
      actionsElement.classList.add('is-visible');
    }
  }

  /**
   * 削除ボタンを非表示
   */
  private hideDeleteButton(): void {
    const actionsElement = this.container.querySelector('.js-file-upload-actions') as HTMLElement;
    if (actionsElement) {
      actionsElement.classList.remove('is-visible');
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  console.log('DOMContentLoaded');
  const contactFileUploaderElements = document.querySelectorAll(".js-contact-file-uploader");
  contactFileUploaderElements.forEach((element) => {
    // 既に初期化済みの要素はスキップ（ContactImageUploaderで初期化済み）
    if (element.getAttribute('data-uploader-initialized')) {
      console.log('Skipping already initialized uploader');
      return;
    }
    new ContactFileUploader(element as HTMLElement);
  });
});